import React, { useEffect, useRef, useState, useCallback } from 'react';
import { MenuList, MenuItem, ClickAwayListener, Stack, Button, Popper, Grow, Paper, Drawer } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import styles from './Menu.module.scss';
import { useWindowSize } from '../../../../utils/hooks';

export function Menu({ options, children, onMenuSelect, isArrowIcon, classes }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  const handleClick = (action) => {
    onMenuSelect(action);
    handleToggle();
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  const prevOpen = useRef(open);
  const screenWidth = useWindowSize().width;

  useEffect(() => {
    if (prevOpen?.current === true && open === false) {
      anchorRef?.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="column" spacing={2}>
      <div className={`${styles.MenuWrapper} ${classes}`}>
        <Button
          className={styles.ButtonComponent}
          ref={anchorRef}
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          endIcon={isArrowIcon && (open ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
          sx={{
            '& .MuiButton-endIcon': {
              display: 'inline-block',
              margin: 0
            }
          }}
        >
          {children}
        </Button>
        <Popper open={open} anchorEl={anchorRef.current} transition>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  {screenWidth <= 576 ? (
                    <Drawer anchor="bottom" open={open} onClose={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                        className={styles.MenuComponent}
                      >
                        {options.map((option) => (
                          <MenuItem
                            disabled={option.disabled}
                            key={option.key}
                            onClick={() => handleClick(option.action)}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Drawer>
                  ) : (
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                      className={styles.MenuComponent}
                    >
                      {options.map((option) => (
                        <MenuItem
                          disabled={option.disabled}
                          key={option.key}
                          onClick={() => handleClick(option.action)}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </MenuList>
                  )}
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
